import { FileTextOutlined } from "@ant-design/icons";
import React, { useMemo } from "react";
import { useAppTranslation } from "~/hooks/useAppTranslation";
import { formatDisplayDateOnly, ROUTES } from "~/utils";
import type { HomePageLoaderData } from "../loaders/HomePageLoader";
import { getLeaseEndUrgency } from "../utils/leaseEndUrgency";
import { HomeActionCard } from "./HomeActionCard";
import { HomeNextSteps } from "./HomeNextSteps";
import { LocationSearchBar } from "~/components/ListingBrowse";

const pageStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 24,
  width: "100%",
  marginTop: 8,
};

export function NonTenantHomeView({
  leaseEndDate,
  pendingLeases,
}: HomePageLoaderData) {
  const { t, i18n } = useAppTranslation();

  const leaseUrgency = getLeaseEndUrgency(leaseEndDate);
  const leaseDescription = useMemo(() => {
    if (!leaseEndDate || !leaseUrgency) {
      return t("Home_view_lease_card_description");
    }
    const formatted = formatDisplayDateOnly(leaseEndDate, i18n.language);
    if (leaseUrgency === "danger") {
      return t("Home_lease_ends_soon", { date: formatted });
    }
    if (leaseUrgency === "warning") {
      return t("Home_lease_ends_upcoming", { date: formatted });
    }
    return t("Home_lease_ends_on", { date: formatted });
  }, [leaseEndDate, leaseUrgency, t, i18n.language]);

  return (
    <div style={pageStyle}>
      <LocationSearchBar
        title={t("Home_find_apartment_title")}
        subtitle={t("Home_search_section_subtitle")}
      />

      <HomeNextSteps pendingLeases={pendingLeases} />

      <HomeActionCard
        to={ROUTES.lease}
        icon={<FileTextOutlined />}
        title={t("Home_view_lease_link")}
        description={leaseDescription}
        urgency={leaseUrgency ?? "default"}
      />
    </div>
  );
}
